var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketplaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_828903416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M203 40c0,-1 0,-1 0,-1l-1 0c0,0 0,0 0,0l1 0c-6,-21 -23,-36 -44,-39l0 0 -54 0 0 0 -1 0 -5 0 -1 0 0 0 -47 0c-24,0 -44,16 -51,38 0,1 0,1 0,2 0,0 0,1 0,1l0 6 0 156 132 0 58 0 13 0 0 -156 0 -6c0,0 0,-1 0,-1zm-47 -33c18,1 33,13 39,30l-43 0 0 0c-3,-13 -12,-24 -23,-30l23 0 4 0zm-10 40c0,12 -9,21 -21,21 -11,0 -20,-9 -20,-21l0 -3 41 0 0 3zm-88 -3l40 0 0 3c0,12 -9,21 -20,21 -11,0 -20,-9 -20,-21l0 -3zm47 -37c19,0 35,13 40,30l-40 0 0 -30zm-7 30l-40 0c5,-17 22,-30 40,-30l0 30zm-47 -30l23 0c-11,6 -19,17 -23,30l0 0 -43 0c6,-18 23,-30 43,-30zm-44 37l43 0 1 0 0 3c0,12 -9,21 -21,21l-3 0c-11,0 -20,-9 -20,-21l0 -3zm176 105l-44 0 0 -36c0,-12 10,-22 22,-22 12,0 22,10 22,22l0 36zm-44 47l0 -40 44 0 0 40 -44 0zm57 -131l0 131 -6 0 0 -83c0,-15 -13,-28 -29,-28 -16,0 -29,13 -29,28l0 70c-2,0 -3,1 -3,3 0,2 1,4 3,4l0 3 -3 0c-2,0 -4,2 -4,3l-3 0c0,-1 -2,-3 -3,-3l-4 0c-2,0 -3,2 -3,3l-4 0c0,-1 -1,-3 -3,-3l-3 0c-2,0 -4,2 -4,3l-3 0c0,-1 -2,-3 -4,-3l-3 0c-2,0 -3,2 -3,3l-4 0c0,-1 -1,-3 -3,-3l-3 0c-2,0 -4,2 -4,3l-3 0c0,-1 -2,-3 -4,-3l-3 0c-2,0 -3,2 -3,3l-4 0c0,-1 -1,-3 -3,-3l-4 0c-1,0 -3,2 -3,3l-3 0c0,-1 -2,-3 -4,-3l-3 0c-2,0 -4,2 -4,3l-3 0c0,-1 -1,-3 -3,-3l-4 0c-2,0 -3,2 -3,3l-3 0c0,-1 -2,-3 -4,-3l-3 0 0 -7 0 -121c0,1 0,1 0,1 1,0 1,1 1,1 1,0 1,0 1,1 1,0 1,0 1,1 1,0 1,0 1,0 1,1 1,1 2,1 0,1 0,1 1,1 0,0 1,0 1,1 0,0 1,0 1,0 1,0 1,1 2,1 0,0 0,0 1,0 0,0 1,0 1,1 1,0 1,0 1,0 1,0 2,0 2,0 1,0 1,0 1,0 1,0 2,1 3,1l3 0c2,0 3,-1 4,-1 0,0 0,0 1,0 1,0 1,0 2,0 1,0 1,-1 1,-1 1,0 2,0 3,-1 0,0 0,0 1,0 0,0 1,-1 2,-1 0,0 1,0 1,-1 1,0 1,-1 2,-1 0,0 0,0 0,-1 1,0 2,-1 3,-2 0,0 0,0 0,0 1,-1 1,-1 2,-2 0,0 0,-1 0,-1 1,-1 2,-1 2,-2 0,0 0,0 0,0 0,0 0,0 0,0 1,1 1,1 2,2 0,0 0,1 0,1 1,1 1,1 2,2 0,0 0,0 1,0 0,1 1,2 2,2 0,1 0,1 0,1 1,0 2,1 3,1 0,1 0,1 0,1 1,0 2,1 3,1 0,0 0,0 0,0 1,1 2,1 3,1 1,0 1,1 1,1 1,0 2,0 3,0 0,0 0,0 1,0 1,0 2,1 3,1 1,0 2,-1 3,-1 1,0 1,0 1,0 1,0 2,0 3,0 0,0 0,-1 1,-1 1,0 2,0 3,-1 0,0 0,0 0,0 1,0 2,-1 2,-1 1,0 1,0 1,-1 1,0 2,-1 2,-1 1,0 1,0 1,-1 1,0 1,-1 2,-2 0,0 1,0 1,0 0,-1 1,-1 1,-2 1,0 1,-1 1,-1 0,-1 1,-1 1,-2 0,0 1,0 1,0 0,0 0,0 0,0 0,1 1,1 1,2 0,0 1,1 1,1 0,1 1,1 1,2 1,0 1,0 1,0 1,1 1,2 2,2 0,1 1,1 1,1 1,0 1,1 2,1 0,1 0,1 1,1 1,0 1,1 2,1 0,0 0,0 1,0 1,1 2,1 3,1 0,0 0,1 1,1 0,0 1,0 2,0 0,0 1,0 1,0 1,0 2,1 3,1 1,0 3,-1 4,-1 0,0 0,0 1,0 0,0 1,0 2,0 0,0 1,-1 1,-1 1,0 2,0 3,-1 0,0 0,0 0,0 1,0 2,-1 3,-1 0,0 0,0 1,-1 0,0 1,-1 2,-1 0,0 0,0 0,-1 1,0 2,-1 3,-2 0,0 0,0 0,0 1,-1 1,-1 2,-2 0,0 0,-1 0,-1 1,-1 1,-1 2,-2 0,0 0,0 0,0 0,0 0,0 0,0 1,1 1,1 2,2 0,0 0,1 0,1 1,1 1,1 2,2 0,0 0,0 0,0 1,1 2,2 3,2 0,1 0,1 0,1 1,0 2,1 2,1 1,1 1,1 1,1 1,0 2,1 3,1 0,0 0,0 0,0 1,1 2,1 3,1 0,0 1,1 1,1 1,0 2,0 2,0 1,0 1,0 1,0 1,0 3,1 4,1l3 0c1,0 2,-1 3,-1 0,0 1,0 1,0 1,0 1,0 2,0 0,0 0,0 1,0 0,-1 1,-1 1,-1 1,0 1,0 2,0 0,0 1,-1 1,-1 0,0 1,0 1,0 1,-1 1,-1 1,-1 1,0 1,0 2,-1 0,0 0,0 1,-1 0,0 0,0 1,0 0,-1 1,-1 1,-1 0,-1 1,-1 1,-1 0,0 1,-1 1,-1 0,0 0,0 0,-1zm-20 3l-3 0c-11,0 -21,-9 -21,-21l0 -3 1 0 43 0 0 3c0,12 -9,21 -20,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M14 179l111 0 0 -94 -111 0 0 94zm6 -88l99 0 0 82 -99 0 0 -82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M51 129c1,0 2,-1 2,-1l14 -14c1,-1 1,-3 0,-5 -2,-1 -4,-1 -5,0l-14 14c-1,1 -1,3 0,5 1,0 2,1 3,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M51 146c1,0 2,-1 2,-1l7 -7c1,-1 1,-4 0,-5 -1,-1 -4,-1 -5,0l-7 7c-1,1 -1,3 0,5 1,0 2,1 3,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M62 126c-1,1 -1,2 -1,3 0,1 0,1 1,2 1,1 1,1 2,1 1,0 2,0 3,-1 0,-1 1,-1 1,-2 0,-1 -1,-2 -1,-3 -2,-1 -4,-1 -5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M69 124c0,1 1,1 2,1 1,0 2,0 3,-1l10 -10c1,-1 1,-3 0,-5 -2,-1 -4,-1 -5,0l-10 11c-2,1 -2,3 0,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M79 126l-31 31c-1,1 -1,3 0,5 1,0 2,1 3,1 1,0 2,-1 2,-1l31 -31c1,-1 1,-3 0,-5 -2,-1 -4,-1 -5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M86 120c-1,0 -1,1 -1,2 0,1 0,2 1,2 0,1 1,1 2,1 1,0 2,0 2,-1 1,0 1,-1 1,-2 0,-1 0,-2 -1,-2 -1,-2 -3,-2 -4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M27 183l-3 0c-2,0 -4,1 -4,3 0,2 2,4 4,4l3 0c2,0 3,-2 3,-4 0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M10 190l4 0c1,0 3,-2 3,-4 0,-2 -2,-3 -3,-3l-4 0c-2,0 -3,1 -3,3 0,2 1,4 3,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M54 183l-3 0c-2,0 -4,1 -4,3 0,2 2,4 4,4l3 0c2,0 4,-2 4,-4 0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M41 183l-4 0c-2,0 -3,1 -3,3 0,2 1,4 3,4l4 0c2,0 3,-2 3,-4 0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M81 183l-3 0c-2,0 -3,1 -3,3 0,2 1,4 3,4l3 0c2,0 4,-2 4,-4 0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M68 183l-4 0c-2,0 -3,1 -3,3 0,2 1,4 3,4l4 0c2,0 3,-2 3,-4 0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M108 183l-3 0c-2,0 -3,1 -3,3 0,2 1,4 3,4l3 0c2,0 4,-2 4,-4 0,-2 -2,-3 -4,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M95 183l-4 0c-1,0 -3,1 -3,3 0,2 2,4 3,4l4 0c2,0 3,-2 3,-4 0,-2 -1,-3 -3,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M122 183l-3 0c-2,0 -4,1 -4,3 0,2 2,4 4,4l3 0c2,0 3,-2 3,-4 0,-2 -1,-3 -3,-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaces);
export default __webpack_public_path__ + "static/media/Marketplaces.2bf2342d9d182f86fe289ea8e05a17d0.svg";
export { ForwardRef as ReactComponent };